@if (options.length > 0) {
  <div class="lib-select-plain-container">
    <div class="select-primary">
      <span
        class="select-arrow"
        [inlineSVG]="
          iconBaseNameAndUrl ? iconBaseNameAndUrl : '/icons/icon-arrow-b-' + (showOptionsList ? 'up' : 'down') + '.svg'
        "
      ></span>
      <input #searchInput class="select-input" (mousedown)="showOptionsList = true" [readonly]="true" />
      <div class="input-search-placeholder">
        <span>{{ selectedOption ? selectedOption.key : (placeholder | transloco) }}</span>
      </div>
      @if (showOptionsList) {
        <div
          #scrollContainer
          class="manual-options-list"
          (appClickOutside)="onClickOutside($event)"
          [exception]="searchInput"
        >
          @for (option of options; track option) {
            <div class="manual-option" (click)="onValueChange(option)">
              <span>
                @if (translation) {
                  {{ option.key | transloco }}
                } @else {
                  {{ option.key }}
                }
              </span>
            </div>
          }
        </div>
      }
      @if (errors && errors.required) {
        <div class="error">
          {{ 'form.error.required' | transloco }}
        </div>
      }
    </div>
  </div>
}
